/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalInstructions
 */
export interface InternalInstructions {
    /**
     * Instructions for navigating the IVR
     * @type {string}
     * @memberof InternalInstructions
     */
    ivr_instructions?: string;
    /**
     * Instructions for the conversation agent
     * @type {string}
     * @memberof InternalInstructions
     */
    conversation_instructions?: string;
}

/**
 * Check if a given object implements the InternalInstructions interface.
 */
export function instanceOfInternalInstructions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InternalInstructionsFromJSON(json: any): InternalInstructions {
    return InternalInstructionsFromJSONTyped(json, false);
}

export function InternalInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalInstructions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ivr_instructions': !exists(json, 'ivr_instructions') ? undefined : json['ivr_instructions'],
        'conversation_instructions': !exists(json, 'conversation_instructions') ? undefined : json['conversation_instructions'],
    };
}

export function InternalInstructionsToJSON(value?: InternalInstructions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ivr_instructions': value.ivr_instructions,
        'conversation_instructions': value.conversation_instructions,
    };
}

